export function isPlaceholderPlate(plate) {
  return /^DRV-?(\d{8}|\d{14})$/i.test(String(plate || ""));
}

export function hasOffsiteLotGuestCard(booking) {
  return booking?.rateCard?.lot?.type === "OFFSITE";
}
